export default "__VITE_ASSET__BcEtB8iJ__"